var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('folders-list-links',{staticClass:"mt16",attrs:{"items":_vm.counterparties}}),(_vm.nextLink)?_c('pagination-panel-default',{attrs:{"if-active":_vm.showLoadData},on:{"load-more":_vm.loadNext}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }